<template>
  <div class="infor-bill">
    <div class="period d-none">
      <h2>KỲ ĐÓNG {{ detailPeriod.title | convertFullDate }}</h2>
    </div>
    <div class="student_name">
      <p>Họ và tên học sinh:</p>
      <span>{{ report.student.name }}</span>
    </div>
    <div class="student_code">
      <p>Mã học sinh:</p>
      <span>{{ report.student.code | getStudentCode }}</span>
    </div>
    <div class="student_class">
      <p>Lớp:</p>
      <span>{{ (report.class && report.class.title) || 'Không có' }}</span>
    </div>
    <div v-if="getCode(kind) !== ''" class="student_class">
      <p>Mã giao dịch:</p>
      <span>{{ getCode(kind) }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    kind: String,
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
      report: 'tuitionFeeReport/report',
    }),
  },
  methods: {
    getCode(kind = '') {
      if (kind === 'cen') return this.report.codeCen
      if (kind === 'decen') return this.report.codeDecen
      return ''
    },
  },
}
</script>
<style lang="scss">
p,
span,
h2,
h3 {
  color: #212121;
}
.infor-bill {
  margin: 10px 0 0 20px;
}
.period {
  padding-top: 12px;
}
.infor-bill h2,
.bill_content_wrap h2 {
  text-transform: uppercase;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  margin: 30px 0;
}
.infor-bill p {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin: 1px 10px 0 0;
}
.infor-bill h2 {
  text-transform: uppercase;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  margin: 30px 0;
}
.infor-bill > .student_name,
.student_code,
.student_class {
  display: flex;
  margin: 8px 0;
}
</style>
